(() => {
  if (window.swChristmasFormsInstalled) return;
  window.swChristmasFormsInstalled = true;
  // Run before Vitals' document-level single-product form interception.
  window.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-sw-christmas-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const original = button.textContent;
    const error = form.querySelector('[role="alert"]');
    error.hidden = true;
    button.disabled = true;
    button.textContent = form.dataset.busy;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(form.action + '.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
      // Mode 1 is Vitals' own after-add action: refresh and show the cart.
      let drawer = window.vtlsCartDrawer;
      for (let attempt = 0; (!drawer || typeof drawer.show !== 'function') && attempt < 40; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 100));
        drawer = window.vtlsCartDrawer;
      }
      try {
        if (drawer && typeof drawer.show === 'function') await drawer.show(1);
        else window.location.assign(form.dataset.cartUrl);
      } catch (_) {
        // The items are already added: show the cart instead of inviting a retry.
        window.location.assign(form.dataset.cartUrl);
      }
    } catch (failure) {
      error.textContent = failure.message || form.dataset.error;
      error.hidden = false;
    } finally {
      button.disabled = false;
      button.textContent = original;
      form.removeAttribute('aria-busy');
    }
  }, true);
})();
